import Pathes from '@/helpers/pathes';
import axios from '@/axios-api';
import { getQuery } from '@/helpers/utils';

export const cashService = {
  finances: () => axios.get(Pathes.Dashboard.finances),
  nextRepayment: () => axios.get(Pathes.Payments.nextPayment),
  repaymentSchedule: params => axios.get(Pathes.Payments.schedule + getQuery(params)),
  repaymentDetail: deadline => axios.get(Pathes.Payments.deadlineDetails(deadline)),
  dashboardBalance: () => axios.get(Pathes.Dashboard.balanceInfo),
  dashboardPayment: () => axios.get(Pathes.Dashboard.paymentInfo),
  bankStatements: params => axios.get(Pathes.User.startupBankStatements + getQuery(params)),
  deleteBankStatement: id => axios.delete(Pathes.User.startupBankStatement(id)),
  uploadBankStatement: payload => axios.post(Pathes.User.startupBankStatements, payload),
};
